export enum ERegistrationTab {
  Info,
  History,
}
